// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-2eXAb","icon":"jgp-2dO4-","description":"jgp-24J8o","button":"jgp-26_gb","personalise":"jgp-28XgU","share":"jgp-1ua6F"};